/**
 * Admin session policy constants
 * ------------------------------------------------------------------
 * Centralised so both the test-login screen (which advertises the policy)
 * and the AdminAuth shell (which enforces it) read the same values.
 */

/** Auto-logout after this much inactivity on a sandbox seat. */
export const TEST_ADMIN_IDLE_MS = 24 * 60 * 60 * 1000; // 24 h

/** Hard cap on a sandbox seat's lifetime, regardless of activity. */
export const TEST_ADMIN_ABSOLUTE_MS = 48 * 60 * 60 * 1000; // 48 h

/** Warning window surfaced to the user before forced logout. */
export const TEST_ADMIN_WARN_MS = 60 * 1000; // 60 s